// import { Box, Button, FormControl, Grid, MenuItem, Select, Snackbar } from '@mui/material';
// import React, { useEffect, useRef, useState } from 'react';
// import TextInputs from 'src/components/inputs/TextInputs';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import ServiceSuggestion from '../Billings/ServiceSuggestion';
// import { IoStar } from "react-icons/io5";
// import ServiceSuggestionAppointment from '../Appointments/ServiceSuggestionAppointment';
// import AddServiceSuggestion from './AddServiceSuggestion';

// const initialValue = {
//   membershipName: '',
//   membershipPrice: '',
//   duration: '',
//   rewardPointsOnPurchase: '',
//   servicesOffered: [
//     {
//       service: '',
//       serviceName: '',
//       availableCount: '',
//     },
//   ],
// };

// const initialFormValidation = {
//   membershipNameValidation: false,
//   membershipPriceValidation: false,
//   durationValidation: false,
//   servicesOfferedValidation: [
//     {
//       serviceValidation: false,
//       availableCountValidation: false,
//     },
//   ],
// };

// const ServiceMembership = ({ membershipType = "serviceType" }) => {
//   const { createMembership, activeBranchId, getBranch, setShowMessage } = useMain();

//   const [formData, setFormData] = useState({ ...initialValue, membershipType });
//   const [formValidation, setFormValidation] = useState(initialFormValidation);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [servicesCat, setServicesCat] = useState([])
//   const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
//   const [serviceSuggested, setServiceSuggested] = useState([]);
//   const [isMouseOverSuggestion, setIsMouseOverSuggestion] = useState(false);

//   const membershipNameInputRef = useRef(null);
//   const serviceInputRefs = useRef([]);

//   const membershipNameValidation = !formData.membershipName.trim();
//   const membershipPriceValidation =
//     !formData.membershipPrice || !(Number(formData.membershipPrice) > 0);
//   const durationValidation = !formData.duration || !(Number(formData.duration) > 0);
//   const servicesOfferedValidation = formData.servicesOffered.map((item) => ({
//     serviceValidation: !item.service.trim(),
//     availableCountValidation: !item.availableCount || !(Number(item.availableCount) > 0),
//   }));

//   // Add this useEffect to focus on the product name field when component mounts
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (membershipNameInputRef.current) {
//         membershipNameInputRef.current.focus();
//       }
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   const updateServiceSuggested = (inputValue) => {
//     const selectedServiceIds = formData.servicesOffered
//       .map(service => service.service)
//       .filter(serviceId => serviceId);

//     if (inputValue.trim() === '') {
//       setServiceSuggested([]);
//       return;
//     }

//     const serviceSuggestions = services.filter(
//       service =>
//         service.serviceName.toLowerCase().includes(inputValue.toLowerCase()) &&
//         !selectedServiceIds.includes(service._id)
//     );
//     setServiceSuggested(serviceSuggestions);
//   };

//   const handleServiceInputChange = (e, index) => {
//     const { name, value } = e.target;
//     if (name === 'service') {
//       const updatedservicesOffered = [...formData.servicesOffered];
//       updatedservicesOffered[index]["service"] = "";
//       updatedservicesOffered[index]["serviceName"] = value;
//       setFormData((prev) => ({ ...prev, servicesOffered: updatedservicesOffered }));
//       updateServiceSuggested(value);
//       setFocusedServiceIndex(index);
//     }
//   };

//   const handleServiceSuggestedClick = (service) => {
//     const index = focusedServiceIndex;
//     const updatedservicesOffered = [...formData.servicesOffered];
//     updatedservicesOffered[index]["service"] = service?._id;
//     updatedservicesOffered[index]["serviceName"] = service?.serviceName;
//     setFormData((prev) => ({ ...prev, servicesOffered: updatedservicesOffered }));
//     setServiceSuggested([]);
//     setFocusedServiceIndex(null);
//   };

//   // Handle input change
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Add a new row for service
//   const addServiceRow = () => {
//     const hasUnselectedService = formData.servicesOffered.some(
//       (item) => item.service === '' || item.availableCount == 0,
//     );

//     if (!hasUnselectedService) {
//       setFormData((prevData) => ({
//         ...prevData,
//         servicesOffered: [
//           ...prevData.servicesOffered,
//           {
//             service: '',
//             serviceName: '',
//             availableCount: '',
//           },
//         ],
//       }));
//       // Focus on the new service input after the state updates
//       setTimeout(() => {
//         const lastIndex = formData.servicesOffered.length;
//         if (serviceInputRefs.current[lastIndex]) {
//           serviceInputRefs.current[lastIndex].focus();
//         }
//       }, 100);
//     } else {
//       setShowMessage({
//         message: 'Select a service and count for the existing row(s) before adding a new row.',
//         messageType: 'error',
//       });
//     }
//   };

//   // Remove a service row
//   const removeServiceRow = (index) => {
//     setFormData((prevData) => {
//       const updatedServicesOffered = [...prevData.servicesOffered];
//       updatedServicesOffered.splice(index, 1);
//       return {
//         ...prevData,
//         servicesOffered: updatedServicesOffered,
//       };
//     });
//   };

//   // Handle change in service select and count
//   const handleChange = (e, index) => {
//     const { name, value } = e.target;
//     const updatedServicesOffered = [...formData.servicesOffered];
//     updatedServicesOffered[index] = {
//       ...updatedServicesOffered[index],
//       [name]: value,
//     };
//     setFormData((prevData) => ({
//       ...prevData,
//       servicesOffered: updatedServicesOffered,
//     }));
//   };

//   // Handle form submission
//   const handleSubmit = async () => {
//     const { membershipName, membershipPrice, duration, servicesOffered } = formData;

//     const validation = {
//       membershipNameValidation: !membershipName.trim(),
//       membershipPriceValidation: !membershipPrice || !(Number(membershipPrice) > 0),
//       durationValidation: !duration || !(Number(duration) > 0),
//       servicesOfferedValidation: servicesOffered.map((item) => ({
//         serviceValidation: !item.service.trim(),
//         availableCountValidation: !item.availableCount || !(Number(item.availableCount) > 0),
//       })),
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (
//       Object.values(validation).some((item) =>
//         Array.isArray(item)
//           ? item.some(
//             (nestedItem) => nestedItem.serviceValidation || nestedItem.availableCountValidation,
//           )
//           : item,
//       )
//     )
//       return;

//     try {
//       setLoading(true);
//       const res = await createMembership(
//         JSON.stringify({
//           ...formData,
//           branchDetails: activeBranchId,
//         }),
//       );

//       if (res?.statusCode === 200) {
//         setFormData({ ...initialValue, membershipType });
//         setFormValidation((pre) => ({ ...initialFormValidation }));
//         setShowMessage({
//           message: res.message || 'Service Type Membership created successfully',
//           messageType: 'success',
//         });
//       } else {
//         setShowMessage({ message: res.message || 'Membership not created', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const getData = async () => {
//       try {
//         const res = await getBranch(activeBranchId);
//         const services = res?.data.services || [];
//         setServices(services);

//         const servicesByCategory = services.reduce((acc, service) => {
//           const { category = "Others", ...rest } = service;
//           if (!acc[category]) {
//             acc[category] = [];
//           }
//           acc[category].push(rest);
//           return acc;
//         }, {});

//         setServicesCat(servicesByCategory);
//       } catch (error) {
//         console.error(error);
//       }
//     };

//     if (activeBranchId) {
//       getData();
//     }

//     return () => {
//       setServices([]);
//     };
//   }, [activeBranchId]);

//   const [isFocused, setIsFocused] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   return (
//     <div>
//       <Box style={{ marginTop: '20px' }}>
//         <Grid container spacing={4}>
//           <Grid item xs={12} md={4.5}>
//             <TextInputs
//               title={'Membership Name'}
//               ref={membershipNameInputRef}
//               name={'membershipName'}
//               value={formData?.membershipName}
//               handleChange={handleInputChange}
//               type={'text'}
//               placeholder={'Membership Name'}
//               fieldValidation={membershipNameValidation && formValidation.membershipNameValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <TextInputs
//               title={'Duration (in Months)'}
//               name={'duration'}
//               placeholder={'0'}
//               value={formData?.duration}
//               handleChange={handleInputChange}
//               type={'number'}
//               min={'0'}
//               fieldValidation={durationValidation && formValidation.durationValidation}
//             />
//           </Grid>
//           <Grid item xs={12} md={3}>
//             <TextInputs
//               title={'Membership Price'}
//               name={'membershipPrice'}
//               placeholder={'0'}
//               value={formData?.membershipPrice}
//               handleChange={handleInputChange}
//               type={'number'}
//               min={'0'}
//               fieldValidation={
//                 membershipPriceValidation && formValidation.membershipPriceValidation
//               }
//             />
//           </Grid>
//         </Grid>
//       </Box>
//       {formData.servicesOffered.map((item, index) => (
//         <Box style={{ marginTop: '20px' }} key={index}>
//           <Grid container spacing={4}>
//             <Grid item xs={12} md={4}>
//               <label>Services<IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginBottom: '10px' }} /></label>
//               <input
//                 type="text"
//                 ref={(el) => (serviceInputRefs.current[index] = el)}
//                 className={`form-control ${item?.serviceName === '' ? 'border border-2' : ''}`}
//                 placeholder="Service"
//                 name="service"
//                 value={item?.serviceName}
//                 onChange={(e) => handleServiceInputChange(e, index)}
//                 autoComplete='off'
//                 style={{
//                   padding: '14px',
//                   border: '1px solid #dee2e6',
//                   outline: isFocused ? '2px solid #6174DD' : 'none', 
//                 }}
//                 onFocus={() => {
//                   setIsFocused(true);
//                   setFocusedServiceIndex(index);
//                 }}
//                 onBlur={() => {
//                   // Only hide suggestions if not hovering over them
//                   setTimeout(() => {
//                     if (!isMouseOverSuggestion) {
//                       setIsFocused(false);
//                       setFocusedServiceIndex(null);
//                       setServiceSuggested([]);
//                     }
//                   }, 200);
//                 }}
//                 onMouseEnter={() => setIsHovered(true)}
//                 onMouseLeave={() => setIsHovered(false)}
//               />
//               {item?.service === '' && (
//                 <div className="text-danger"></div>
//               )}

//               {serviceSuggested.length > 0 && focusedServiceIndex === index && (
//                 <AddServiceSuggestion
//                   data={serviceSuggested}
//                   handleServiceSuggestedClick={handleServiceSuggestedClick}
//                   inputRef={serviceInputRefs.current[index]}
//                   setServiceSuggested={setServiceSuggested}
//                   focusedServiceIndex={focusedServiceIndex}
//                   setIsMouseOverSuggestion={setIsMouseOverSuggestion}
//                 />
//               )}
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <TextInputs
//                 title={'Count'}
//                 name={'availableCount'}
//                 placeholder={'0'}
//                 value={item.availableCount}
//                 handleChange={(e) => handleChange(e, index)}
//                 type={'number'}
//                 min={'0'}
//                 fieldValidation={
//                   servicesOfferedValidation[index]?.availableCountValidation &&
//                   formValidation.servicesOfferedValidation[index]?.availableCountValidation
//                 }
//               />
//             </Grid>
//             <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center' }}>
//               <Grid item xs={12} md={4} mt={'22px'}>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   target="_blank"
//                   sx={{
//                     background: '#6174DD',
//                     width: '100px',
//                     fontSize: '14px',
//                     fontWeight: 'bold',
//                     marginTop: '0.35rem',
//                   }}
//                   onClick={addServiceRow}
//                 >
//                   Add
//                 </Button>
//               </Grid>
//               {index !== 0 ? (
//                 <Grid item xs={12} md={4} mt={'22px'}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     target="_blank"
//                     sx={{
//                       background: '#ff0000',
//                       width: '100px',
//                       fontSize: '14px',
//                       fontWeight: 'bold',
//                       marginTop: '0.35rem',
//                       '&:hover': {
//                         background: '#ff6666',
//                       },
//                     }}
//                     onClick={() => removeServiceRow(index)}
//                   >
//                     Remove
//                   </Button>
//                 </Grid>
//               ) : (
//                 ''
//               )}
//             </Grid>
//           </Grid>
//         </Box>
//       ))}

//       {loading ? (
//         <ShowLoader />
//       ) : (
//         <div style={{ width: '200px', margin: '3rem auto' }}>
//           <Button
//             variant="contained"
//             fullWidth
//             color="primary"
//             target="_blank"
//             sx={{
//               background: '#6174DD',
//             }}
//             onClick={handleSubmit}
//           >
//             Create Membership
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServiceMembership;

import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Snackbar } from '@mui/material';
import React, { useEffect, useRef, useState, useMemo } from 'react';
import TextInputs from 'src/components/inputs/TextInputs';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SelectInputs from 'src/components/inputs/SelectInputs';
import { IoStar } from "react-icons/io5";
import AddServiceSuggestion from './AddServiceSuggestion';

const initialValue = {
  membershipName: '',
  membershipPrice: '',
  durationType: '',
  duration: '',
  validTill: '',
  rewardPointsOnPurchase: '',
  taxStatus: 'noGst',
  servicesOffered: [
    {
      service: '',
      serviceName: '',
      availableCount: '',
    },
  ],
};

const taxStatusOptions = [
  { value: 'withTax', label: 'Inclusive (5% GST)' },
  { value: 'withoutTax', label: 'Exclusive (5% GST)' },
  // { value: 'noGst', label: 'No GST' },
];

const DurationTypes = [
  { value: 'duration', label: 'Duration (in Months)' },
  { value: 'validTill', label: 'Valid Till Date' }
];

const initialFormValidation = {
  membershipNameValidation: false,
  membershipPriceValidation: false,
  durationTypeValidation: false,
  durationValidation: false,
  validTillValidation: false,
  taxStatusValidation: false,
  servicesOfferedValidation: [
    {
      serviceValidation: false,
      availableCountValidation: false,
    },
  ],
};

const ServiceMembership = ({ membershipType = "serviceType" }) => {
  const { createMembership, activeBranchId, getBranch, setShowMessage, branchData } = useMain();

  const [formData, setFormData] = useState({ ...initialValue, membershipType });
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [servicesCat, setServicesCat] = useState([])
  const [focusedServiceIndex, setFocusedServiceIndex] = useState(null);
  const [serviceSuggested, setServiceSuggested] = useState([]);
  const [isMouseOverSuggestion, setIsMouseOverSuggestion] = useState(false);
  const [isPriceInputFocused, setIsPriceInputFocused] = useState(false);

  const membershipNameInputRef = useRef(null);
  const serviceInputRefs = useRef([]);

  const isGstRequired = !!(branchData?.gstNumber && branchData.gstNumber.trim().length > 0);

  const membershipNameValidation = !formData.membershipName.trim();
  const membershipPriceValidation = !formData.membershipPrice || !(Number(formData.membershipPrice) > 0);
  const durationTypeValidation = !formData.durationType;
  const durationValidation = formData.durationType === 'duration' && (!formData.duration || !(Number(formData.duration) > 0));
  const validTillValidation = formData.durationType === 'validTill' && !formData.validTill;
  const taxStatusValidation = isGstRequired && (formData.taxStatus === 'noGst' || !formData.taxStatus);
  const gstValidation = !formData.gst;
  const servicesOfferedValidation = formData.servicesOffered.map((item) => ({
    serviceValidation: !item.service.trim(),
    availableCountValidation: !item.availableCount || !(Number(item.availableCount) > 0),
  }));

  const taxableValue = useMemo(() => {
    const p = Number(formData.membershipPrice) || 0;
    if (!isGstRequired) {
      return p.toFixed(2);
    }
    if (formData.taxStatus === 'withTax') {
      return (p / 1.05).toFixed(2);
    }
    return p.toFixed(2);
  }, [formData.membershipPrice, formData.taxStatus, isGstRequired]);

  // Add this useEffect to focus on the product name field when component mounts
  useEffect(() => {
    const timer = setTimeout(() => {
      if (membershipNameInputRef.current) {
        membershipNameInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const updateServiceSuggested = (inputValue) => {
    const selectedServiceIds = formData.servicesOffered
      .map(service => service.service)
      .filter(serviceId => serviceId);

    if (inputValue.trim() === '') {
      setServiceSuggested([]);
      return;
    }

    const serviceSuggestions = services.filter(
      service =>
        service.serviceName.toLowerCase().includes(inputValue.toLowerCase()) &&
        !selectedServiceIds.includes(service._id)
    );
    setServiceSuggested(serviceSuggestions);
  };

  const handleServiceInputChange = (e, index) => {
    const { name, value } = e.target;
    if (name === 'service') {
      const updatedservicesOffered = [...formData.servicesOffered];
      updatedservicesOffered[index]["service"] = "";
      updatedservicesOffered[index]["serviceName"] = value;
      setFormData((prev) => ({ ...prev, servicesOffered: updatedservicesOffered }));
      updateServiceSuggested(value);
      setFocusedServiceIndex(index);
    }
  };

  const handleServiceSuggestedClick = (service) => {
    const index = focusedServiceIndex;
    const updatedservicesOffered = [...formData.servicesOffered];
    updatedservicesOffered[index]["service"] = service?._id;
    updatedservicesOffered[index]["serviceName"] = service?.serviceName;
    setFormData((prev) => ({ ...prev, servicesOffered: updatedservicesOffered }));
    setServiceSuggested([]);
    setFocusedServiceIndex(null);
  };

  // Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Add a new row for service
  const addServiceRow = () => {
    const hasUnselectedService = formData.servicesOffered.some(
      (item) => item.service === '' || item.availableCount == 0,
    );

    if (!hasUnselectedService) {
      setFormData((prevData) => ({
        ...prevData,
        servicesOffered: [
          ...prevData.servicesOffered,
          {
            service: '',
            serviceName: '',
            availableCount: '',
          },
        ],
      }));
      // Focus on the new service input after the state updates
      setTimeout(() => {
        const lastIndex = formData.servicesOffered.length;
        if (serviceInputRefs.current[lastIndex]) {
          serviceInputRefs.current[lastIndex].focus();
        }
      }, 100);
    } else {
      setShowMessage({
        message: 'Select a service and count for the existing row(s) before adding a new row.',
        messageType: 'error',
      });
    }
  };

  // Remove a service row
  const removeServiceRow = (index) => {
    setFormData((prevData) => {
      const updatedServicesOffered = [...prevData.servicesOffered];
      updatedServicesOffered.splice(index, 1);
      return {
        ...prevData,
        servicesOffered: updatedServicesOffered,
      };
    });
  };

  // Handle change in service select and count
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedServicesOffered = [...formData.servicesOffered];
    updatedServicesOffered[index] = {
      ...updatedServicesOffered[index],
      [name]: value,
    };
    setFormData((prevData) => ({
      ...prevData,
      servicesOffered: updatedServicesOffered,
    }));
  };

  const handleDurationTypeChange = (e) => {
    const { value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      durationType: value,
      duration: value === 'duration' ? prevFormData.duration : '',
      validTill: value === 'validTill' ? prevFormData.validTill : '',
    }));
  };

  // Handle form submission
  const handleSubmit = async () => {
    const { membershipName, membershipPrice, durationType, duration, validTill, taxStatus, servicesOffered } = formData;

    const validation = {
      membershipNameValidation: !membershipName.trim(),
      membershipPriceValidation: !membershipPrice || !(Number(membershipPrice) > 0),
      durationTypeValidation: !durationType,
      durationValidation: durationType === 'duration' && (!duration || !(Number(duration) > 0)),
      validTillValidation: durationType === 'validTill' && !validTill,
      taxStatusValidation: isGstRequired && (taxStatus === 'noGst' || !taxStatus),
      servicesOfferedValidation: servicesOffered.map((item) => ({
        serviceValidation: !item.service.trim(),
        availableCountValidation: !item.availableCount || !(Number(item.availableCount) > 0),
      })),
    };

    setFormValidation((pre) => ({ ...pre, ...validation }));

    if (
      Object.values(validation).some((item) =>
        Array.isArray(item)
          ? item.some(
            (nestedItem) => nestedItem.serviceValidation || nestedItem.availableCountValidation,
          )
          : item,
      )
    )
      return;

    try {
      setLoading(true);

      const payload = {
        membershipName: formData.membershipName.trim(),
        membershipPrice: Number(formData.membershipPrice) || 0,
        membershipType: formData.membershipType,
        taxStatus: isGstRequired ? formData.taxStatus : 'noGst',
        taxableValue: taxableValue,
        servicesOffered: formData.servicesOffered.map(service => ({
          service: service.service,
          serviceName: service.serviceName,
          availableCount: Number(service.availableCount) || 0
        })),
        branchDetails: activeBranchId,
      };

      // Add either duration or validTill based on selection with proper type conversion
      if (durationType === 'duration') {
        payload.duration = Number(duration);
        // Don't send validTill when using duration
      } else {
        payload.validTill = validTill;
        // Don't send duration when using validTill
      }

      const res = await createMembership(JSON.stringify(payload));

      if (res?.statusCode === 200) {
        setFormData({ ...initialValue, membershipType });
        setFormValidation((pre) => ({ ...initialFormValidation }));
        setShowMessage({
          message: res.message || 'Service Type Membership created successfully',
          messageType: 'success',
        });
      } else {
        setShowMessage({ message: res.message || 'Membership not created', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const res = await getBranch(activeBranchId);
        const services = res?.data.services || [];
        setServices(services);

        const servicesByCategory = services.reduce((acc, service) => {
          const { category = "Others", ...rest } = service;
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(rest);
          return acc;
        }, {});

        setServicesCat(servicesByCategory);
      } catch (error) {
        console.error(error);
      }
    };

    if (activeBranchId) {
      getData();
    }

    return () => {
      setServices([]);
    };
  }, [activeBranchId]);

  const [isFocused, setIsFocused] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // This logic disables the mouse wheel event
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };

    window.addEventListener('wheel', handleWheel);
    return () => {
      window.removeEventListener('wheel', handleWheel);
    };
  }, []);

  return (
    <div>
      {/* First Row: All fields dynamically arranged */}
      <Box style={{ marginTop: '20px' }}>
        <Grid container spacing={3}>
          {/* Membership Name */}
          <Grid item xs={12} md={3}>
            <TextInputs
              title={'Membership Name'}
              ref={membershipNameInputRef}
              name={'membershipName'}
              value={formData?.membershipName}
              handleChange={handleInputChange}
              type={'text'}
              placeholder={'Membership Name'}
              fieldValidation={membershipNameValidation && formValidation.membershipNameValidation}
            />
          </Grid>

          {/* Duration Type */}
          <Grid item xs={12} md={3} style={{marginTop:'30px'}}>
            <FormControl fullWidth error={formValidation.durationTypeValidation}>
              <InputLabel>Duration Type</InputLabel>
              <Select
                value={formData.durationType}
                onChange={handleDurationTypeChange}
                label="Duration Type"
              >
                <MenuItem value="" disabled>
                  Select Duration Type
                </MenuItem>
                {DurationTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Conditional Duration Field */}
          {formData.durationType === 'duration' && (
            <Grid item xs={12} md={3}>
              <TextInputs
                title={'Duration (in Months)'}
                name={'duration'}
                placeholder="0"
                min={'1'}
                value={formData?.duration}
                handleChange={handleInputChange}
                type={'number'}
                fieldValidation={durationValidation && formValidation.durationValidation}
              />
            </Grid>
          )}

          {formData.durationType === 'validTill' && (
            <Grid item xs={12} md={3}>
              <TextInputs
                title={'Valid Till Date'}
                name={'validTill'}
                value={formData?.validTill}
                handleChange={handleInputChange}
                type={'date'}
                fieldValidation={validTillValidation && formValidation.validTillValidation}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <label style={{
                fontSize: "15px",
                fontWeight: 600,
                marginBottom: "8px",
                display: "inline-block",
                color: "#212529"
              }}>Membership Price
                <IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginLeft: '4px' }} />
              </label>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: `1px solid ${isPriceInputFocused ? '#6174DD' : '#ced4da'}`, // Dynamic border color
                  borderRadius: '4px',
                  height:"57px",
                  transition: 'border-color 0.2s ease-in-out', // Smooth transition
                  '&:hover': {
                    borderColor: '#6174DD', // Theme color on hover
                  },
                }}
              >
                <span style={{padding: '0px 8px', fontSize: '16px', color: '#666'}}>₹</span>
                <input
                  name="membershipPrice"
                  placeholder="0"
                  value={formData.membershipPrice}
                  onChange={handleInputChange}
                  type="number"
                  min="0"
                  style={{
                    border: 'none',
                    outline: 'none',
                    flex: 1,
                    padding: '12px 0px',
                    fontSize: '16px',
                    background: 'transparent',
                    width: '100%'
                  }}
                  onFocus={() => setIsPriceInputFocused(true)}
                  onBlur={() => setIsPriceInputFocused(false)}
                />
                {isGstRequired && (
                  <Select
                    name="taxStatus"
                    value={formData.taxStatus || 'noGst'}
                    onChange={handleInputChange}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                    sx={{
                      background: '#F0F0F0',
                      border: 'none',
                      height: '100%',
                      borderTopLeftRadius: '0px',
                      borderBottomLeftRadius: '0px',
                      borderTopRightRadius: '3px',
                      borderBottomRightRadius: '3px',
                      '& .MuiSelect-select': {
                        padding: '8px 16px',
                        paddingRight: '24px !important',
                        height: '100% !important',
                        display: 'flex',
                        alignItems: 'center'
                      },
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: 'none'
                      },
                      '&:hover': {
                        background: '#e0e0e0',
                      },
                      '&.Mui-focused': {
                        background: '#e0e0e0',
                      },
                      borderLeft: '1px solid #ced4da'
                    }}
                  >
                    {taxStatusOptions.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Box>
              {isGstRequired && (
                <Box sx={{
                  p: '8px 12px',
                  backgroundColor: '#e9ecef',
                  border: '1px solid #ced4da',
                  borderTop: 'none',
                  borderRadius: '0 0 4px 4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
                </Box>
              )}
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      {/* Service Rows */}
      {formData.servicesOffered.map((item, index) => (
        <Box style={{ marginTop: '2px' }} key={index}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <label>Services<IoStar color='red' style={{ height: '6px', fontWeight: 'bold', marginBottom: '10px' }} /></label>
              <input
                type="text"
                ref={(el) => (serviceInputRefs.current[index] = el)}
                className={`form-control ${item?.serviceName === '' ? 'border border-2' : ''}`}
                placeholder="Service"
                name="service"
                value={item?.serviceName}
                onChange={(e) => handleServiceInputChange(e, index)}
                autoComplete='off'
                style={{
                  padding: '14px',
                  border: '1px solid #dee2e6',
                  outline: isFocused ? '2px solid #6174DD' : 'none', 
                }}
                onFocus={() => {
                  setIsFocused(true);
                  setFocusedServiceIndex(index);
                }}
                onBlur={() => {
                  // Only hide suggestions if not hovering over them
                  setTimeout(() => {
                    if (!isMouseOverSuggestion) {
                      setIsFocused(false);
                      setFocusedServiceIndex(null);
                      setServiceSuggested([]);
                    }
                  }, 200);
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
              {item?.service === '' && (
                <div className="text-danger"></div>
              )}

              {serviceSuggested.length > 0 && focusedServiceIndex === index && (
                <AddServiceSuggestion
                  data={serviceSuggested}
                  handleServiceSuggestedClick={handleServiceSuggestedClick}
                  inputRef={serviceInputRefs.current[index]}
                  setServiceSuggested={setServiceSuggested}
                  focusedServiceIndex={focusedServiceIndex}
                  setIsMouseOverSuggestion={setIsMouseOverSuggestion}
                />
              )}
            </Grid>
            <Grid item xs={12} md={2}>
              <TextInputs
                title={'Count'}
                name={'availableCount'}
                placeholder={'0'}
                value={item.availableCount}
                handleChange={(e) => handleChange(e, index)}
                type={'number'}
                min={'0'}
                fieldValidation={
                  servicesOfferedValidation[index]?.availableCountValidation &&
                  formValidation.servicesOfferedValidation[index]?.availableCountValidation
                }
              />
            </Grid>
            <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center' }}>
              <Grid item xs={12} md={4} mt={'22px'}>
                <Button
                  variant="contained"
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                    width: '100px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    marginTop: '0.35rem',
                  }}
                  onClick={addServiceRow}
                >
                  Add
                </Button>
              </Grid>
              {index !== 0 ? (
                <Grid item xs={12} md={4} mt={'22px'}>
                  <Button
                    variant="contained"
                    color="primary"
                    target="_blank"
                    sx={{
                      background: '#ff0000',
                      width: '100px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginTop: '0.35rem',
                      '&:hover': {
                        background: '#ff6666',
                      },
                    }}
                    onClick={() => removeServiceRow(index)}
                  >
                    Remove
                  </Button>
                </Grid>
              ) : (
                ''
              )}
            </Grid>
          </Grid>
        </Box>
      ))}

      {loading ? (
        <ShowLoader />
      ) : (
        <div style={{ width: '200px', margin: '3rem auto' }}>
          <Button
            variant="contained"
            fullWidth
            color="primary"
            sx={{
              background: '#6174DD',
            }}
            onClick={handleSubmit}
          >
            Create Membership
          </Button>
        </div>
      )}
    </div>
  );
};

export default ServiceMembership;
